//#region src/v2/blocks/scalar-address-bar-block/components/httpStatusCodeColors.ts
var STATUS_CODES_COLORS = {
	100: { color: "text-yellow" },
	200: { color: "text-green" },
	202: { color: "text-green" },
	300: { color: "text-blue" },
	304: { color: "text-blue" },
	400: { color: "text-red" },
	401: { color: "text-orange" },
	422: { color: "text-yellow" },
	423: { color: "text-purple" },
	505: { color: "text-orange" }
};
var getStatusCodeColor = (statusCode) => {
	return STATUS_CODES_COLORS[statusCode] || { 
	/** default color */
color: "text-grey" };
};
//#endregion
export { getStatusCodeColor };

//# sourceMappingURL=httpStatusCodeColors.js.map